import {FilesFoldersWidget} from '../memory/component/Admin';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {AdminMemoryParams,FolderHierarchy, MemoryFile} from "../memory/component/Types";

// Was "export default", but then https://github.com/Microsoft/TypeScript/issues/6962
export class RepositoryFileList {

	private form:HTMLFormElement;

	constructor(private params:AdminMemoryParams, private folders:FolderHierarchy[], private files:MemoryFile[], private parentNode:Element) {
		this.form = $('form[name=my_form]')[0] as HTMLFormElement;
	}

	public render() {
		ReactDOM.render(
			<FilesFoldersWidget
				fieldName="knowledge2MemoryFiles"
				folders={this.folders}
				files={this.files}
				memoryParams={this.params}
				folderDeletedCallback={(id) => { this.folderDeleted(id); return true; }}
				fileDeletedCallback={(id) => { this.fileDeleted(id); return true; }}
				folderSelectedCallback={(id, memoryInstance) => { this.folderSelected(id, memoryInstance); return true; }}
				fileSelectedCallback={(id, memoryInstance) => { this.fileSelected(id, memoryInstance); return true;}}
			/>,
			this.parentNode
		);
	}

	private appendHiddenInput(name:string, value:number|string) {
		const input = document.createElement('input');
		input.type = 'hidden';
		input.name = name;
		input.value = value.toString();
		this.form.appendChild(input);
	}

	private folderDeleted(folderId:number) {
		this.appendHiddenInput('delete_repository_category', folderId);
		this.form.submit();
	}

	private fileDeleted(fileId:number) {
		const message = "Are you sure you want to remove this document from this article?";
		if (confirm(message)) {
			this.appendHiddenInput('filesToggledForDeletion[]', fileId);
			this.form.submit();
		}
	}

	private folderSelected(id:number, memoryInstance:string) {
		this.appendHiddenInput('memory_category_selected', id);
		this.appendHiddenInput('memory_instance', memoryInstance);
		this.form.submit();
	}

	private fileSelected(id:number, memoryInstance:string) {
		this.appendHiddenInput('memory_file_selected', id);
		this.appendHiddenInput('memory_instance', memoryInstance);
		this.form.submit();
	}
}



// WEBPACK FOOTER //
// ./src/knowledge2/RepositoryFileList.tsx